import React from 'react';

const getParams = (url) => {
    let pageParams = {}
    let urlParams = new URLSearchParams(url);
    for (const param of urlParams.entries()) {
        pageParams[param[0]] = param[1];
    }
    return pageParams;
};



export default getParams;




// WEBPACK FOOTER //
// ./src/components/utilities/getParams.js